import { Box } from "@mui/material";
import React, { useRef } from "react";
import GetAiReady from "../GetAiReady/GetAiReady";
import Subscription from "../Subscription/Subscription";
import Comparefeature from "../Comparefeature/Comparefeature";
import CoreFeatures from "../CoreFeatures/CoreFeatures";
import Frequently from "../Frequently/Frequently";

function Pricing() {
  const PricingRef = useRef(null);
  const SubscriptionRef = useRef(null);

  return (
    <Box>
      <Box ref={PricingRef}>
        <GetAiReady />
      </Box>
      <Box ref={SubscriptionRef}>
        <Subscription />
      </Box>
      <Box>
        <Comparefeature />
      </Box>
      <Box>
        <CoreFeatures />
      </Box>
      <Box>
        <Frequently />
      </Box>
    </Box>
  );
}

export default Pricing;
